import "./App.css";

import "./styles/main.scss";
import AppRoutes from "./routes/index";

import { useEffect } from "react";
import { useTranslation } from "react-i18next";

function App() {
  /**
   * Sincronizar el atributo lang de la app con el idioma seleccionado
   */
  useEffect(() => {
    document.documentElement.lang = i18n?.resolvedLanguage ?? i18n?.language;
  }, []);

  const { i18n } = useTranslation();

  return (
    <div>
      <AppRoutes />
    </div>
  );
}

export default App;
